document.addEventListener('DOMContentLoaded', () => {
    const minVisitors = 5;
    const maxVisitors = 9;

    function updateVisitorCount() {
        const randomVisitors = Math.floor(Math.random() * (maxVisitors - minVisitors + 1)) + minVisitors;
        const visitorElement = document.getElementById('visitor-number');
        if (visitorElement) {
            visitorElement.innerText = randomVisitors;
        }
    }

    updateVisitorCount();
    setInterval(updateVisitorCount, 60000);
});
